import { render, staticRenderFns } from "./list-widget.vue?vue&type=template&id=254cf2c2&scoped=true&"
import script from "./list-widget.vue?vue&type=script&lang=js&"
export * from "./list-widget.vue?vue&type=script&lang=js&"
import style0 from "./list-widget.vue?vue&type=style&index=0&id=254cf2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254cf2c2",
  null
  
)

export default component.exports